import { render, staticRenderFns } from "./WowClassicNaxxramasComponent.vue?vue&type=template&id=2178b930&"
import script from "./WowClassicNaxxramasComponent.vue?vue&type=script&lang=js&"
export * from "./WowClassicNaxxramasComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports